'use client'
import LoginOrRegister from './LoginOrRegister'
import { useSearchParams } from 'next/navigation'

export default function Page() {
  const searchParams = useSearchParams()
  const RedirectUrl = searchParams.get('RedirectUrl')
  return <LoginOrRegister RedirectUrl={RedirectUrl} />
}
